export default {
  infoLabel: 'Informações do Componente',
  closeLabel: 'Fechar informações',
  faq: {
    title: 'Como funciona o filtro?',
    description: 'As categorias são agregadas e cada sub-categoria dividida através dos espaços em cada tag',
  },
  faq2: {
    title: 'O que é visualizado?',
    description: 'O gráfico mostra apenas as tags selecionadas, qualquer outra tag que não esteja selecionada no filtro, mesmo que presente nas publicações filtradas, não irá aparecer no gráfico',
  },
};
